export const WIDGET_ID = 202000001949;
export const WIDGET_URL = 'https://euc-widget.freshworks.com/widgets/202000001949.js';
